import {ExtendedPropertyType, ResourceType} from 'common/report/constants';

import {isPersistedCustomProperty} from '../custom-property-modal/util';
import type {PropertyItem} from '../query-block/properties-menu/types';

/** Validates the given property is eligible to be ephemerally mapped to a lookup table.
 * Returns an error string, or null if the prop can be mapped.
 *
 * Note that we do allow overriding a saved lookup table mapping
 */
export function propIneligibleForMappingReason(prop: Omit<PropertyItem, 'label'> | Obj, temp = false): string | null {
  if (!prop?.resourceType) {
    return `Cannot map this property: only Event and User Properties are supported`;
  }

  let error = null;
  if (![ResourceType.User, ResourceType.Event].includes(prop.resourceType)) {
    error = `Cannot map this property: only Event and User Properties are supported`;
    // @ts-ignore Typing is trying to check two different Enums
    // Todo: Review [PropertyItem.type: PropertyType]
  } else if (Object.values(ExtendedPropertyType).includes(prop.type)) {
    error = `Cannot map this property: "${prop.type}" type not supported`;
  } else if ((prop.customProperty || prop.customPropertyId) && !isPersistedCustomProperty(prop.customPropertyId)) {
    error = `Cannot map this property: temporary custom properties are not supported`;
  } else if (Array.isArray(prop.value)) {
    error = `Cannot map a lookup table property to another lookup table`;
  } else if (temp && prop.tempDataGroupId) {
    error = `Cannot map this property: already temporarily mapped. Please first remove the temporary mapping.`;
  } else if (prop.dataGroupId && !prop.joinPropertyType) {
    error = `Cannot map this property: non-User profiles are not supported`;
  }
  return error;
}

/**
 * Return boolean if confirmation is needed to overwrite mapping
 */
export function confirmPropertyMapOverwrite(prop: Omit<PropertyItem, 'label'> | EmptyObj): boolean {
  if ((prop.dataGroupId || prop.dimensionDataGroupId) && prop.joinPropertyType) {
    return true;
  }
  return false;
}
